module.exports = __webpack_public_path__ + "static/fem-032f88d361322c4807c8b4b17b10eb97.png";